var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconThemeColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EB4D4D",
    d: "M11.5 0A11.46 11.46 0 0 0 1.13 16.45L16.45 1.13A11.44 11.44 0 0 0 11.5 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#43A047",
    d: "M23 11.5c0-1.77-.41-3.45-1.13-4.95L6.55 21.87a11.41 11.41 0 0 0 13.08-2.24A11.46 11.46 0 0 0 23 11.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF8F00",
    d: "M16.44 1.12v.01L1.14 16.45a11.55 11.55 0 0 0 5.42 5.42L21.87 6.55a11.55 11.55 0 0 0-5.43-5.43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThemeColor);
export default ForwardRef;